import { useQuery } from "@tanstack/react-query";
import { useAxios } from "../useAxios";
import { QuizDetailsDto, QuizStatisticsFilter } from "../../types/quiz-statistics";

export const useGetQuizDetails = (
  examId: string | null,
  filter: QuizStatisticsFilter,
  enabled = true
) => {
  const axios = useAxios();

  return useQuery({
    queryKey: ["quizDetails", examId, filter],
    queryFn: async (): Promise<QuizDetailsDto> => {
      const params = new URLSearchParams();
      if (filter.startDate) params.append("startDate", filter.startDate);
      if (filter.endDate) params.append("endDate", filter.endDate);
      const query = params.toString() ? `?${params.toString()}` : "";
      const { data } = await axios.get(`/api/challenges/QuizDetails/${examId}${query}`);
      return data;
    },
    enabled: enabled && !!examId,
    refetchInterval: 15_000,
  });
};
